import { PlannerPoi } from 'components/common/types/Planner.types';

export const getPoiElementRadius = (poiElement: PlannerPoi): number => poiElement.properties.visibility.radius || 0;
